import React from 'react';
import { withFormik, Field, Form, getIn } from 'formik';
import { Button, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { FormikDatePicker, FormikInput, FormikSelect } from '../../components';
import JobManagementsFilter from '../../components/Utils/Filters/JobManagementsFilter';
import JobTitlesFilter from '../../components/Utils/Filters/JobTitlesFilter';

const statusOptions = [
  { label: 'Activo', value: 'active' },
  { label: 'Suspendido', value: 'suspended' },
  { label: 'Desierto', value: 'deserted' },
  { label: 'Cerrado', value: 'closed' },
  { label: 'Generado', value: 'generated' }
];

const processTypeOptions = [
  { label: 'Interno', value: 'internal' },
  { label: 'Externo', value: 'external' },
  { label: 'Mixto', value: 'mixed' }
];

const SelectionProcessFilter = props => {
  const { errors, touched, setFieldValue, setFieldTouched } = props;
  const { currentCompany } = useSelector(state => state.auth);

  return (
    <Form className="employee-search-form py-4 pl-4 mb-2">
      <Row>
        <Col xs={12} md={3} className="px-5">
          <Field name="filterName">
            {({ field }) => (
              <FormikInput
                {...field}
                label="Nombre del Proceso:"
                placeholder="Ej: Selección Desarrollador"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>

        <Col xs={12} md={{ span: 3 }} className="px-5">
          <Field name="filterDateFrom">
            {({ field }) => (
              <FormikDatePicker
                {...field}
                abbr
                isOutsideRange={() => false}
                appendToBody
                repositionPickerOnUpdate
                showClearDate
                label="Fecha desde"
                placeholder="dd/mm/aaaa"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>

        <Col xs={12} md={{ span: 3 }} className="px-5">
          <JobManagementsFilter formikValue="filterJobManagement" params={{ company_id: currentCompany }} />
        </Col>

        <Col xs={12} md={{ span: 3 }} className="px-5">
          <JobTitlesFilter formikValue="filterJobTitle" params={{ company_id: currentCompany }} />
        </Col>
      </Row>

      <Row className="mt-2">
        <Col xs={12} md={3} className="px-5">
          <Field name="filterProcessType">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Tipo de Proceso:"
                placeholder="Seleccione"
                options={processTypeOptions}
                onChange={opt => setFieldValue(field.name, opt ? opt.value : '')}
                setFieldTouched={() => setFieldTouched(field.name)}
                isClearable
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>

        <Col xs={12} md={{ span: 3 }} className="px-5">
          <Field name="filterStatus">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Estado:"
                placeholder="Seleccione"
                options={statusOptions}
                onChange={opt => setFieldValue(field.name, opt ? opt.value : '')}
                setFieldTouched={() => setFieldTouched(field.name)}
                isClearable
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={12} md={{ span: 3, offset: 9 }} className="d-flex align-items-end px-5">
          <Button className="btn-block" type="submit">
            FILTRAR
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const handleSubmit = (values, { props }) => {
  props.formRequest(values);
};

export default withFormik({
  mapPropsToValues: () => ({
    filterName: '',
    filterDateFrom: '',
    filterJobManagement: '',
    filterJobTitle: '',
    filterProcessType: '',
    filterStatus: ''
  }),
  handleSubmit,
  enableReinitialize: true
})(SelectionProcessFilter);
